var inRAF = false;
export function cancel(handle) {
    if (handle) {
        cancelAnimationFrame(handle);
    }
}
export function runBeforeLayout(callback) {
    if (inRAF) {
        callback();
        return;
    }
    else {
        return requestAnimationFrame(function () {
            inRAF = true;
            callback();
            Promise.resolve().then(function () {
                // In a Microtask, which will run after all the work of the Task has completed,
                // turn off the "this.inRAF" flag, as we are about to exit the rAF context.
                inRAF = false;
            });
        });
    }
}
export function runAfterPaint(callback) {
    return runBeforeLayout(function () { return setTimeout(callback, 0); });
}
//# sourceMappingURL=browser-paint-utility.js.map